// 中文语言包
export default {
  email: {
    title: "写邮件",
    replyTitle: "回复邮件",
    forwardTitle: "转发邮件",
    send: "发送",
    to: "收件人",
    cc: "抄送",
    bcc: "密送",
    subject: "主题",
    addAttachment: "添加附件",
    camera: "相机",
    photo: "照片",
    video: "视频",
    attachment: "附件",
    contactExists: "联系人已存在",
    noEmail: "该联系人没有邮箱",
    mailLoading: "加载中",
    all: "全部",
    addressor: "发件人",
    inbox: "收件箱",
    drafts: "草稿箱",
    sentItems: "已发送",
    deletedItems: "已删除",
    junkEmail: "垃圾邮件",
    detailTitle: "详情",
    replyAll: "回复全部",
    reply: "回复",
    forward: "转发",
    delete: "删除",
    details: "详情",
    noSubject: "无主题",
    when: "时间",
    location: "地址",
    accept: "接受",
    wait: "等待",
    refuse: "拒绝",
    sendSuccess: "发送成功",
    sendFailed: "发送失败",
    selectFiltered: "已删除部分未开通邮箱账号用户"
  },
  delMail: {
    delConfirm: "删除确认",
    delTip: "您确定删除吗？删除后手机端将不能恢复，需要通过outlook恢复",
    delAll: '您确认删除么？删除后将无法恢复',
    delFailed: "删除失败",
    delSuccess: "删除成功"
  },
  writeMail: {
    saveTip: "是否保留为草稿",
    saveOk: "保留",
    saveNo: "不保留",
    saveFail: "保存失败",
    saveSuccess: "保存成功"
  },
  meeting: {
    operationSuc: "操作成功",
    operationFail: "操作失败",
    creatorOperateTip: "您是会议创建者，无需操作"
  },
  contactSearch: {
    noMoreData: "没有更多了",
    loading: "加载中",
    loadMore: "点击加载更多"
  },
  attachment: {
    uploading: "上传中",
    uploadFailed: "上传失败",
    overMaxSize: "最多只能上传100M附件",
    overFileMaxSize: "单个附件最多不能超过30M",
    noSupportPreview: "该文件不支持预览"
  },
  common: {
    cancel: "取消",
    confirm: "确定",
    delet: '删除',
    hint: '提示',
    fnDevTip: "功能开发中"
  },
  page404: {
    pageNotExist: '抱歉，你访问的页面不存在',
    moreTip: '该页面已经删除，或者正在建设中，敬请期待',
    backHome: '返回首页'
  },
  ajaxErr: {
    notLogin: '用户未登录或登录已过期!',
    networkErr: '网络连接失败，请检查网络设置。',
    isCancel: '请求被取消',
    apiRequestFail: '接口请求失败!',
    timeout: '操作频繁'
  },
  home: {
    seach: '搜索',
    end: '已经到页面最底部啦',
    loading: '加载中...',
    success: '标记成功',
    recipients: '收件人未填写',
    subjectless: '无主题',
    maxList: '批量操作最多100条邮件，请分批操作'
  },
  header: {
    Inbox: '收件箱',
    chooseEma: '选择邮件',
    all: '全选',
    deselectAll: '取消全选',
    sign: '标记',
    tagR: '标记为已读',
    tagW: '标记为未读',
  },
  wx: {
    selectUserErr: "通讯录调用失败,请稍后重试!"
  },
  // 翻译
  translate: {
    selectTranslateLan: "选择翻译语言",
    translateEmail: "翻译邮件",
    translateing: "翻译中...",
    translateFail: "翻译失败",
    showOrigin: "显示原文",
    showTranslate: "显示翻译",
    translateTip: "以下内容为自动翻译结果，仅供参考。"
  },
  isRead: {
    all: '全部',
    unread: '未读',
    read: '已读'
  }
}
